import { useRef } from 'react';
import useEffectOnLoad from './useEffectOnLoad';

function useIsMounted() {
    const isMountedRef = useRef(false);
    useEffectOnLoad(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    });
    return () => isMountedRef.current;
}

export default useIsMounted;
